// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
//const apiUrl = "http://161.97.127.212:9874/datasnap/rest/";
export const environment = {
  production: true,

  //production: false,
  appVersion: 'v726demo2',
  USERDATA_KEY: 'authf649fc9a5f55',
  isMockEnabled: true,
  apiRoot: '//161.97.127.212:9874/datasnap/rest/',
  apiUrl: 'https://your-domain.com/api'
  // rootUrl: `${apiUrl}`
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
